import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" id=\"icon-mail\"><g transform=\"translate(1 1)\" stroke=\"currentColor\" fill=\"none\"><rect width=\"14\" height=\"10\" rx=\"1.5\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.52.5L7 5 13.512.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-mail.svg
// module id = 881
// module chunks = 74